<div class="footer-container">
    <p class="to-right">COPYRIGHT &copy; {{year}} ADRIA-ELECTRONIC</p>
</div>
